<template>
	<div>
		<v-alert v-if="error" type="error" dense outlined class="mb-4">
			{{ error }}
		</v-alert>
		<div v-if="email" class="text-caption text-center grey--text text--darken-1 mb-3">
			Accesso come <strong>{{ email }}</strong>
		</div>

		<template v-if="mode === 'enroll'">
			<div class="text-subtitle-1 font-weight-bold mb-1">Configura la verifica in due passaggi</div>
			<div class="text-body-2 grey--text text--darken-1 mb-4">
				Inquadra il codice QR con un'app di autenticazione (ad esempio Google Authenticator o Microsoft Authenticator),
				poi inserisci il codice a 6 cifre che compare nell'app.
			</div>
			<v-img :src="qrcode" width="220" max-width="100%" class="mx-auto mb-2" alt="Codice QR per l'app di autenticazione"></v-img>
			<div v-if="issuer" class="text-caption text-center grey--text text--darken-1 mb-3">
				Nell'app comparirà come <strong>{{ issuer }}</strong>
			</div>
			<div class="text-caption text-center grey--text text--darken-1">
				Non riesci a inquadrarlo? Inserisci questa chiave nell'app:
			</div>
			<div class="d-flex align-center justify-center mb-4">
				<code class="text-body-2">{{ formattedSecret }}</code>
				<v-btn icon small class="ml-1" aria-label="Copia la chiave" @click="copySecret">
					<v-icon small :color="copied ? 'success' : 'primary'">{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
				</v-btn>
			</div>
		</template>
		<div v-else class="text-body-2 text-center grey--text text--darken-1 mb-4">
			<v-icon large color="primary" class="d-block mb-2">mdi-cellphone-key</v-icon>
			Inserisci il codice a 6 cifre generato dall'app di autenticazione.
		</div>

		<div class="mx-auto" style="max-width: 300px">
			<v-otp-input
				ref="otp"
				v-model="otp"
				length="6"
				type="number"
				aria-label="Codice di verifica a 6 cifre"
				:disabled="loading"
				@finish="submit"
			></v-otp-input>
		</div>

		<!-- Nella configurazione ogni invio deve contenere il codice: una
		     richiesta senza OTP genera un nuovo secret e il QR mostrato non
		     varrebbe piu'. -->
		<v-btn
			color="primary"
			block
			large
			class="mt-4"
			:loading="loading"
			:disabled="otp.length !== 6"
			@click="submit"
		>
			Verifica
		</v-btn>
		<v-btn text block class="mt-2" :disabled="loading" @click="$emit('back')">
			Torna indietro
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'PortalTwoFactorStep',
	props: {
		mode: String,
		email: String,
		qrcode: String,
		secret: String,
		issuer: String,
		loading: Boolean,
		error: String
	},
	data() {
		return {
			otp: '',
			copied: false
		}
	},
	computed: {
		formattedSecret() {
			return (this.secret || '').replace(/(.{4})/g, '$1 ').trim()
		}
	},
	watch: {
		// Codice errato o bloccato: si riparte da un campo vuoto, col cursore pronto
		error(value) {
			if (value) {
				this.otp = ''
				this.focusOtp()
			}
		},
		// Dalla verifica si puo' tornare alla configurazione (2FA azzerata nel frattempo)
		mode() {
			this.otp = ''
			this.focusOtp()
		}
	},
	mounted() {
		this.focusOtp()
	},
	methods: {
		focusOtp() {
			this.$nextTick(() => {
				if (this.$refs.otp) {
					this.$refs.otp.focus()
				}
			})
		},
		submit() {
			if (this.loading || this.otp.length !== 6) return
			this.$emit('submit', this.otp)
		},
		async copySecret() {
			try {
				if (navigator.clipboard) {
					await navigator.clipboard.writeText(this.secret)
				} else {
					const input = document.createElement('input')
					input.value = this.secret
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
				}
				this.copied = true
				setTimeout(() => { this.copied = false }, 2000)
			} catch (e) {
				// la chiave resta visibile e si puo' copiare a mano
			}
		}
	}
}
</script>
